export default function flag(flag) {
  if (typeof window === 'undefined' || !window.features) {
    return false;
  }

  return window.features[flag] === true;
};